import React, { FC } from "react";

import { Avatar, Box, Skeleton, Stack } from "@mui/material";

import { AlbumAuthorName, AlbumTitle, AvaibleForTypography } from "@pages/Catalog/components/components";

import { useIsDesktop } from "@hooks/layout";

import { IAlbumsSkeleton } from "./index";

const CatalogueLoading: FC<IAlbumsSkeleton> = ({ isCollapsed = false }) => {
  const isDesktop = useIsDesktop();

  return isDesktop ? (
    <Box gridColumn={isDesktop ? "span 6" : "span 12"}>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={isCollapsed ? "16px" : "24px"}>
        <Box gridColumn={isDesktop ? `span ${isCollapsed ? 7 : 6}` : "span 12"}>
          <Skeleton sx={{ borderRadius: "8px", width: "clamp(280px, 100%, 409px)", height: "auto", aspectRatio: "1 / 1" }} />
        </Box>

        <Box gridColumn={isDesktop ? `span ${isCollapsed ? 5 : 6}` : "span 12"}>
          <Stack width="100%" spacing={isCollapsed ? "8px" : "24px"}>
            <Stack spacing="8px" width="100%">
              <AlbumTitle>
                <Skeleton />
              </AlbumTitle>

              <Stack direction="row" alignItems="center" spacing="8px" width="100%">
                <Skeleton variant="circular">
                  <Avatar sx={{ width: "34px", height: "34px" }} />
                </Skeleton>

                <AlbumAuthorName style={{ width: "25%" }}>
                  <Skeleton />
                </AlbumAuthorName>
              </Stack>
            </Stack>

            <Skeleton height="120px" />
          </Stack>
        </Box>

        <Box gridColumn="span 12">
          <Stack width="100%" spacing="16px">
            <Stack direction="row" spacing="8px" width="100%" alignItems="center">
              <Box width="20%" maxWidth="83px">
                <AvaibleForTypography>
                  <Skeleton />
                </AvaibleForTypography>
              </Box>

              <Box width="90px" height="32px">
                <Skeleton
                  height="100%"
                  width="100%"
                  sx={{
                    borderRadius: "64px",
                  }}
                />
              </Box>

              <Box width="90px" height="32px">
                <Skeleton
                  height="100%"
                  width="100%"
                  sx={{
                    borderRadius: "64px",
                  }}
                />
              </Box>
            </Stack>
            <Stack spacing="24px" width="100%">
              <Stack spacing={isCollapsed ? "8px" : "16px"} width="100%">
                <Skeleton height="68px" sx={{ borderRadius: "8px" }} />
                <Skeleton height="68px" sx={{ borderRadius: "8px" }} />
              </Stack>

              <Skeleton width="50%" height="48px" sx={{ maxWidth: "214px" }} />
            </Stack>
          </Stack>
        </Box>
      </Box>
    </Box>
  ) : (
    <Box gridColumn="span 12">
      <Stack width="100%" height="100%">
        <Skeleton height="464px" sx={{ borderRadius: "8px" }} />
      </Stack>
    </Box>
  );
};

export default CatalogueLoading;
